import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {IbMamService} from '../ib-mam.service';
import {AppService} from '../../../app.service';
import {Constants} from '../../../shared/utils/constants';
import {FormControl, NgForm} from '@angular/forms';
import { MamMasterRecord } from './mam-master.type';
// @ts-ignore
import Fuse from './search.mdl';

declare var $: any;
@Component({
  selector: 'fx-mam-master',
  templateUrl: './mam-master.component.html',
  styleUrls: ['./mam-master.component.sass']
})
export class MamMasterComponent implements OnInit, AfterViewInit {
  @ViewChild('form') form: NgForm;
  @ViewChild('form') formMam: NgForm;
  @Input() permission;
  data = [];
  cacheData: MamMasterRecord[] = [];
  condition: any = {
    keyword: ''
  };
  pageInfo: any = {
    pageIndex: 1,
    pageSize: 10,
    totalRecord: 0,
  };
  params: any = {};
  options: any = {};
  mamGroupName = [];
  /*listAllowMethod = [
    'Equity',
    'Balance',
    'Even',
    'Cash_Equity',
    'Cash_Balance',
    'Cash_Even',
    'Lot'
  ];*/
  listAllowMethod = [
    'Equity',
    'Cash_Equity',
  ];
  formCreate: any = {
    txtEmail: {},
  };
  myControlCreate = new FormControl();
  listAccountComplete = [];
  mamMasterIBInfo: any = {};
  isEdit = true;
  currentIndexEdit = null;
  groupConfigSelect: any = {};
  constructor(
    private service: IbMamService,
    private appService: AppService
  ) {
    Object.keys(Constants.LABEL_MT4_GROUP).map(v => {
      if (v.indexOf('MAM') > -1) {
        this.mamGroupName.push(this.reFormatMapName(v));
      }
    });
  }

  reFormatMapName = (str: string) => {
    if(str.length > 0){
      if(str.indexOf('USD') === -1){
        let lastChar = str.substr(str.length - 1);
        str = str.substring(0, str.length - 1) + '00' + lastChar;
      }
    }
    return str;
  }

  ngOnInit(): void {
    this.params.page_size  = this.pageInfo.pageSize;
    this.params.page = 1;
    this.getMamMaster();
  }

  searchTransaction(): void {
    this.params.q = (this.condition.keyword) ? encodeURIComponent((this.condition.keyword).trim()) : this.condition.keyword;
    this.data = this.cacheData.filter(e => {
      if(!this.condition.keyword || !this.condition.keyword.length) {
        return true;
      }
      const search = e.email + e.firstName + e.lastName + e.middleName + e.userId;
      return search.toLowerCase().includes(this.condition.keyword?.toLowerCase()?.trim().replace(' ', ''));
    });
  }

  private getMamMaster(): void {
    this.service.getMamMaster(this.params)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.data = res.data;
          this.cacheData = res.data;
          if(this.condition.keyword !== ''){
            this.data = this.data.filter(v => v.email.includes(this.condition.keyword));
          }
          if (res.paging) {
            this.pageInfo.totalRecord = res.paging.total;
          }
        }
      });
  }
  onChangeProcess(type, id): void {
    if (type === 2) {
      this.appService
        .confirm({
          title: `Are you sure that you want to Reject?`,
          ok: 'Yes',
          cancel: 'No',
        })
        .subscribe((v: any) => {
          if (v.result) {
            this.processUpdateMam(type, id);
          }
        });
    } else {
      this.options.id = +(id);
      this.options.type = +(type);
    }
  }
  private processUpdateMam(type, id, group = ''): void {
    const body = {
      mt4_request_mam_master_account_id: +(id),
      status: +(type)
    };
    if (group) {
      body['group_name'] = group;
    }
    this.service.updateProcessMamAccount(body)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.appService.showSuccess('Update process mam master success');
          $('#modalChangeGroupName .close').trigger('click');
          this.getMamMaster();
        }
      });
  }
  onSubmitApprove(): void {
    if (this.form.valid) {
      this.processUpdateMam(this.options.type, this.options.id, this.options.group);
    }
  }

  pageChanged(page: number): void {
    this.pageInfo.pageIndex = page;
    this.params.page = page;
    // this.getMamMaster();
  }

  searchAccount(): void {
    this.listAccountComplete = [];
    const option = {
      q: this.formCreate.txtEmail
    }
    this.service.getAccountMamLevel(option)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.listAccountComplete = res.data.map(v => {
            const record = {id: v.user_id, email: v.email, name: v.last_name + ' ' + v.first_name};
            return record;
          });
        }
      });
  }
  displayFn(user: any): string {
    return user && user.email ? user.email : '';
  }
  onCreateMamMaster(): void {
    if ((this.myControlCreate.value.id)
      && this.formCreate.allowMethod
      && this.formCreate.group) {
      const body = {
        user_id: +(this.myControlCreate.value.id),
        allocation_method: this.formCreate.allowMethod,
        group_name: this.formCreate.group,
        rate_payout: this.formCreate.ratePayout / 100,
        data: {
          commission: this.formCreate.commission / 100,
          pip: this.formCreate.pip,
          rate: this.formCreate.rate / 100
        }
      }
      this.service.createAccountMamMaster(body)
        .subscribe(res => {
          if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
            this.appService.showSuccess('Create account mam master success');
            this.formCreate = {
              txtEmail: {},
            };
          }
        });
    } else {
      return;
    }
  }

  getMamMasterInfo(item): void {
    this.groupConfigSelect = item;
    const listConfig = item.groupConfigs.map(v => {
      v.percent = +((v.rate_payout * 100).toFixed(2));
      return v;
    });
    this.mamMasterIBInfo = {
      name: item.email,
      data: listConfig
    };
  }
  onEdit(item): void {
    if (item) {
      this.isEdit = true;
      this.currentIndexEdit = item.login;
    } else {
      this.isEdit = false;
      this.currentIndexEdit = null;
      this.getMamMasterInfo(this.groupConfigSelect);
    }
  }
  onSave(item): void {
    const body = {
      mt5_master_mam_account_id: item.mt5_master_mam_account_id,
      rate_payout: (item.percent / 100)
    };
    this.onSubmitChangeRate(body);
  }
  private onSubmitChangeRate(body): void {
    this.service.updateRateMamMaster(body)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.appService.showSuccess('Update rate payout success.');
          this.isEdit = false;
          this.currentIndexEdit = null;
        }
      });
  }
  ngAfterViewInit(): void {
    $('#modalMamMasterIB').on('hide.bs.modal', () => {
      localStorage.setItem('un_loading', 'true');
      this.getMamMaster();
    });
  }
}
